module.exports = __webpack_public_path__ + "static/media/iconATV.269bd703.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconATV.svg
// module id = 897
// module chunks = 0